<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
<!--            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('商品id')" prop="goodsId">
                <a-input v-model="queryParam.goodsId" :maxLength="32" :placeholder="$t('请输入')+$t('商品id')" allow-clear/>
              </a-form-item>
            </a-col>-->
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('上级分类')" prop="pid">
                <a-select style="width: 100%"  show-search
                          :filter-option="filterOption"  @change="handlePidChange"
                          v-model="queryParam.parentId" :placeholder="$t('请输入')+$t('上级分类')">
                  <a-select-option v-for="(item, index) in list" :value="item.id" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
                <a-button style="margin-left: 8px" @click="foldAllRows"><a-icon type="redo" />{{$t('折叠全部')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd(undefined,undefined, queryParam.goodsId)" v-hasPermi="['goods:goodsproperty:add']">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['goods:goodsproperty:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>-->
<!--        <a-tooltip>
          <a-button type="dashed" @click="openCopy"  v-hasPermi="['goods:goodsproperty:add']">
            <a-icon type="copy" />复制到其他商品
          </a-button>
          <template slot="title">
            <p>全部属性将复制到其他商品</p>
          </template>
        </a-tooltip>-->
        <a-tooltip>
          <a-button type="primary" :disabled="multiple"  @click="copyPropertyId" >
            <a-icon type="copy" />复制
          </a-button>
          <template slot="title">
            <p>选中的属性将复制到粘贴板</p>
          </template>
        </a-tooltip>
        <a-button type="danger"   @click="handleOpenPaste" v-hasPermi="['goods:goodsproperty:add']" >
          <a-icon type="diff" />粘贴
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList"/>
      <goods-radio-select ref="goodsRadioSelect" @goodsSelect="goodsPropertyCopy"/>
      <a-modal :visible="pasteVisible" :confirmLoading="pasteLoading" :title="'粘贴'" @ok="handlePasteOk" @cancel="handlePasteCancel">
        <a-input
          type="textarea"
          placeholder="请粘贴"
          v-model="pasteTxt"
          maxlength="100000"
          :rows="28"
          show-word-limit
          style="height: 200px;"
          class="textarea">
        </a-input>
      </a-modal>
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 1200 }"
        id="draggable-table"
        class="draggable-table"
        :expandRowByClick="false"
        :loading="loading"
        :size="tableSize"
        :expanded-row-keys.sync="expandedRowKeys"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
      >
        <span slot="inputType" slot-scope="text, record">
           <custom-dict-tag :options="customDict.GoodsInputTypeEnum" :value="record.inputType"/>
        </span>
        <template slot="sort" slot-scope="text, record">
          <div class="drag-handle" v-if="expandedRowKeys.length===0" >
            <a-icon style="font-size: 16px;color: #00afff;margin-right: 8px" type="drag" />
            <span class="sort-number">{{record.sort}}</span>
          </div>
          <div v-else>
            {{record.sort}}
          </div>
        </template>
        <template slot="picture" slot-scope="text, record">
          <div>
            <img v-if="record.picture" :src="record.picture"  style="width:60px;height:60px;" @click="handleRecordPreview(record.picture)" alt="none"/>
          </div>
        </template>
        <span slot="insureLimit" slot-scope="text, record">
          <span v-if="record.type!==3 || record.level>1">{{record.insureLimit}}</span>
        </span>
        <span slot="insurePrice" slot-scope="text, record">
          <span v-if="record.type!==3 || record.level>1">{{record.insurePrice}}</span>
        </span>
        <span slot="isDefaultSelect" slot-scope="text, record">
           <custom-dict-tag :options="customDict.TFEnum" :value="record.isDefaultSelect"/>
        </span>
        <span slot="isRequire" slot-scope="text, record">
           <custom-dict-tag :options="customDict.TFEnum" :value="record.isRequire"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider  type="vertical" v-hasPermi="['goods:goodsproperty:edit']" />
          <a  @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['goods:goodsproperty:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a>
          <a-divider  type="vertical" v-hasPermi="['goods:goodsproperty:remove']" />
          <a  @click="handleDelete(record)" v-if="record.type===3" v-hasPermi="['goods:goodsproperty:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a>
          <a-divider  type="vertical" v-if="record.level <=1" v-hasPermi="['goods:goodsproperty:add']" />
          <a @click="$refs.createForm.handleAdd(record.id,record.inputType,record.goodsId)" v-if="record.level <=1 && record.type===3" v-hasPermi="['goods:goodsproperty:add']">
             <a-icon type="plus" />添加下级
          </a>
        </span>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  pageGoodsProperty,
  existGoodsProperty,
  copyGoodsProperty,
  delGoodsProperty,
  sortProperty,
  copyGoodsIdProperty, listGoodsProperty
} from '@/api/goods/goodsProperty'
import { getId } from '@/api/merchant/merchantMerchant'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import GoodsRadioSelect from '@/views/goods/goods/select/GoodsRadioSelect.vue'
import { tableMixin } from '@/store/table-mixin'
import Sortable from 'sortablejs'

export default {
  name: 'GoodsProperty',
  components: {
    CustomDictTag,
    GoodsRadioSelect,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: [ '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      pasteVisible: false,
      pasteLoading: false,
      pasteTxt: undefined,
      showChildren: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      expandedKeys: [],
      ids: [],
      loading: false,
      total: 0,
      goodsId: undefined,
      // 查询参数
      queryParam: {
        parentId: undefined,
        goodsId: undefined,
        name: undefined,
        configType: undefined,
        inputType: undefined,
        price: undefined,
        unit: undefined,
        tips: undefined,
        isDefaultSelect: undefined,
        isRequire: undefined,
        picture: undefined,
        pageNum: 1,
        pageSize: 20
      },
      expandedRowKeys:[],
      columns: [
        {
          title: this.$t('名称'),
          dataIndex: 'name',
          ellipsis: true,
          align: 'left'
        },
        {
          title: '商品名称',
          dataIndex: 'goodsName',
          ellipsis: true,
          align: 'center'
        },
        /*{
          title: this.$t('输入类型'),
          dataIndex: 'inputType',
          scopedSlots: { customRender: 'inputType' },
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: this.$t('保额'),
          dataIndex: 'insureLimit',
          scopedSlots: { customRender: 'insureLimit' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('保费'),
          dataIndex: 'insurePrice',
          scopedSlots: { customRender: 'insurePrice' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '排序',
          dataIndex: 'sort',
          scopedSlots: { customRender: 'sort' },
          ellipsis: true,
          align: 'center',
          width: '100px'
        },
        {
          title: this.$t('是否默认选择'),
          dataIndex: 'isDefaultSelect',
          scopedSlots: { customRender: 'isDefaultSelect' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('是否必选'),
          dataIndex: 'isRequire',
          scopedSlots: { customRender: 'isRequire' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '10%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getGoodsId()
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted() {
    this.getGoodsId()
    this.$nextTick(() => {
      this.initDrop()
    })
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    getGoodsId() {
      let goodsId = this.$route.query.goodsId;
      if (goodsId) {
        this.goodsId = goodsId;
        console.log('goodsId',this.queryParam.goodsId)
      }
    },
    /** 查询商品属性列表 */
    getList () {
      this.loading = true
      if (this.queryParam.parentId) {
        this.showChildren = true
      } else {
        this.showChildren = false
      }
      this.queryParam.goodsId = this.goodsId
      listGoodsProperty(this.queryParam).then(response => {
        this.list = response.data
        this.loading = false
        // 默认展开所有层级
        this.$nextTick(() => {
          this.expandAllRows()
        })
      })
    },
    /** 展开所有有子节点的行 */
    expandAllRows () {
      const expandedKeys = []
      // 如果数据是嵌套结构（有 children 字段）
      const hasChildrenField = this.list.some(item => item.children && item.children.length > 0)

      if (hasChildrenField) {
        // 递归收集所有有子节点的节点 id
        const collectExpandedKeys = (items) => {
          items.forEach(item => {
            if (item.children && item.children.length > 0) {
              expandedKeys.push(item.id)
              collectExpandedKeys(item.children)
            }
          })
        }
        collectExpandedKeys(this.list)
      } else {
        // 如果是平铺结构，通过 parentId 关联
        this.list.forEach(item => {
          // 检查是否有其他节点的 parentId 等于当前节点的 id
          const hasChildren = this.list.some(child => child.parentId === item.id)
          if (hasChildren) {
            expandedKeys.push(item.id)
          }
        })
      }
      this.expandedRowKeys = expandedKeys
    },
    foldAllRows () {
      this.expandedRowKeys = []
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handlePidChange(value) {
      this.queryParam.parentId = value
    },
    openCopy() {
      //查询当前商家id
      getId().then(response => {
        this.$refs.goodsRadioSelect.openGoods(null, this.queryParam.goodsId, [response.data.id], [20,21]);
      })
    },
    copyPropertyId() {
      let stringify = JSON.stringify(this.selectedRowKeys);
      navigator.clipboard.writeText(stringify);
      this.$message.success('属性已复制至粘贴板', 3)
    },
    handleOpenPaste() {
      this.pasteVisible =true
    },
    handlePasteOk() {
      this.pasteLoading = true
      let parse = JSON.parse(this.pasteTxt);
      //调用复制接口
      let data = {
        copyIdList :parse,
        targetId :this.goodsId
      }
      copyGoodsIdProperty(data).then(response => {
        this.handlePasteCancel()
        this.getList()
      })
    },

    handlePasteCancel() {
      this.pasteVisible = false
      this.pasteLoading =false
      this.pasteTxt = undefined
    },

    goodsPropertyCopy(records) {
      let goodsId = records[0].id
      console.log('带过来了:',goodsId)
      //查询另一个商品是否有属性
      let query = {"goodsId": goodsId}
      existGoodsProperty(query).then(response => {
        if (response.data) {
          this.$message.error('目标商品下已存在属性,请先删除')
        } else {
          this.goodsPropertyCopyNoConfirm(goodsId)
        }
      })
    },
    goodsPropertyCopyConfirm(goodsId) {
      let sourceId = this.goodsId;
      let data = {"sourceId":sourceId, "targetId": goodsId}
      var that = this
      this.$confirm({
        title: '是否确认复制',
        content: '当前商品下已存在属性,是否确认复制',
        onOk () {
          copyGoodsProperty(data).then(() => {
            that.$message.success('复制成功')
            that.goodsPropertyCopyNoConfirm(goodsId)
          })
        },
        onCancel () {}
      })
    },
    goodsPropertyCopyNoConfirm(goodsId) {
      let sourceId = this.goodsId;
      let data = {"sourceId":sourceId, "targetId": goodsId}
      copyGoodsProperty(data).then(() => {
        this.$message.success('复制成功')
        this.openGoodsPropertyInNewTab(goodsId)
      })
    },

    openGoodsPropertyInNewTab(goodsId) {
      const routeData = this.$router.resolve({
        path: '/goods/property',
        query: { goodsId: goodsId }
      });
      window.open(routeData.href, '_blank');
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        parentId: undefined,
        goodsId: undefined,
        name: undefined,
        configType: undefined,
        inputType: undefined,
        price: undefined,
        unit: undefined,
        tips: undefined,
        isDefaultSelect: undefined,
        isRequire: undefined,
        picture: undefined,
        pageNum: 1,
        pageSize: 20
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    initDrop() {
      const tbody = document.querySelector('.draggable-table tbody')
      if (!tbody) return

      const that = this
      Sortable.create(tbody, {
        handle: '.drag-handle',
        animation: 150,
        onEnd: function ({ oldIndex, newIndex }) {
          if (oldIndex === newIndex) {
            return
          }
          const movedItem = that.list[oldIndex]
          const targetItem = that.list[newIndex]
          console.log(movedItem.name, targetItem.name)
          // Prepare request data
          const data = {
            id1: movedItem.id,
            id2: targetItem.id,
          }
          // Call API to update sort order
          sortProperty(data).then(() => {
            that.getList()
            that.$message.success('排序更新成功')
          })
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delGoodsProperty(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(
                message,
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/goods/goods/property/export',
            that.queryParam
          , `商品属性_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style scoped>
.drag-handle {
  cursor: move;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  transition: background-color 0.3s;
}

.drag-handle:hover {
  border-radius: 4px;
}

.sort-number {
  color: #00afff;
  font-size: 14px;
}
</style>
